export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7465.65680ee9.jpg";